// extracted by mini-css-extract-plugin
module.exports = {"comments__questions":"Comments-module--comments__questions--3pld_","comments":"Comments-module--comments--2ltn8"};